var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.804 4v.731H4.151a.38.38 0 0 0-.378.3l-.006.066v9.806c0 .18.136.329.315.36l.069.006h3.653V16H4.151c-.598 0-1.09-.435-1.146-.991L3 14.903V5.097c0-.57.456-1.039 1.04-1.092L4.15 4h3.654Zm5.369 2.32L17 9.969l-3.827 3.65-.543-.518 2.875-2.742h-9.7v-.756h9.727L12.63 6.837l.543-.517Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.6ef4da38db5ba9a3cc28624008b4aa63.svg";
export { ForwardRef as ReactComponent };